export enum ActionClaimTypeEnum
{
    Claim, //Qu
    Suggestion, //Su
    Survey, //En,
    Ag,
    Al,
    Ep,
    SocialNetwork //Xs
}

export enum ImprovementPlanStatusEnum
{
    InDefinition = 1,
    Scheduled,
    InProgress,
    Finished,
    Proposed
}

export enum ActionStatusEnum
{
    Pending,
    InProgress,
    Closed
}

export enum ObjectiveFinalStatusEnum
{
    Achieved,
    NoAchieved,
    PartiallyAchieved,
    NoTreated,
    NoApply
}